export default defineNuxtPlugin(() => {
    const router = useRouter()

    router.afterEach((to) => {
        // Ждем небольшую паузу, чтобы DOM успел обновиться
        setTimeout(() => {
            if (typeof window.ym !== 'undefined') {
                window.ym(107727876, 'hit', to.fullPath)
            }
        }, 100)
    })
})
